<template>
  <div>
    <ConfirmationBoxes :detail="client">
      <template #box0="{ item }">
        <v-row no-gutters>
          <v-col cols="3">{{
            $t('stock-adjust.stock-adjust_adjustment-date') + ':'
          }}</v-col>
          <v-col>{{ item.adjustDate }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3"> {{ $t('ship.ship_tracking-number') + ':' }} </v-col>
          <v-col>{{ item.trackingNumber }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3">
            {{
              $t('stock-adjust.stock-adjust_inventory-adjustment-reason') + ':'
            }}
          </v-col>
          <v-col>{{ item.adjustReason }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3"
            >{{ $t('stock-adjust.stock-adjust_presentation-target') + ':' }}
          </v-col>
          <v-col>{{ item.target }} </v-col>
        </v-row>
      </template>
      <template #box1="{ item }">
        <v-row no-gutters>
          <v-col class="mb-1 font-weight-bold nameText">{{ item.name }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>{{ item.postalCode ? '〒' + item.postalCode : '' }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>{{ item.address }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            {{ $t('common.input_phone-number') + ':' + item.phone }}
          </v-col>
        </v-row>
      </template>
    </ConfirmationBoxes>
  </div>
</template>
<script>
import { ConfirmationBoxes } from '@/components/items'
import ClientInfoJs from './CustomerInfo'

export default {
  components: {
    ConfirmationBoxes
  },
  props: {
    pageType: { default: 'history' },
    recItems: {
      type: Object,
      require: false,
      default: () => ({})
    }
  },
  created() {
    this.init()
  },
  data: () => ({
    client: []
  }),
  methods: {
    init() {
      if (this.pageType === 'history') {
        this.client = ClientInfoJs.setHistoryInfo(this.recItems)
        return
      } else if (this.pageType === 'register') {
        this.client = ClientInfoJs.setRegisterInfo(this.recItems)
        return
      }
    }
  },
  watch: {
    recItems: {
      deep: true,
      handler(newVal, oldVal) {
        this.init()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.headingStyle {
  font-size: 15px;
  font-weight: bold;
}
</style>
